import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d91ih48t8j: FaireBrandEntity = {
  token: "b_d91ih48t8j",
  type: "brand",
  name: "Cupkin",
  avatarUrl:
    "https://cdn.faire.com/fastly/4010a42609e25fd1fb8102cd77dfcacb2d72a253383b720d1da138704bf49a26.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7e7722a2744b6e44a9a243955fbc00be8b9c572b9bbbcc607b89a52984c571ab.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4010a42609e25fd1fb8102cd77dfcacb2d72a253383b720d1da138704bf49a26.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7e7722a2744b6e44a9a243955fbc00be8b9c572b9bbbcc607b89a52984c571ab.png",
  location: "Bothell, WA, USA",
  minimumOrderDollars: 200,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Cupkin was started with a simple goal: create something meaningful so that our own kids could see what grit looks like.\n\nAs a founder, I wasn’t the primary parent, so building something from the ground up became the way I could lead by example. What started as a small project quickly turned into a mission to create products that kids genuinely love and parents feel good about buying.\n\nWe focus on premium sticker books designed for real play, not just quick entertainment. Each book is thoughtfully designed with a side-by-side layout so kids can stay immersed without flipping back and forth, and filled with hundreds of hand-drawn stickers that make every page feel exciting.\n\nToday, Cupkin has grown into a collection of 60+ titles with over 1 million books sold and a proven best-seller in the Toys & Games category.\n\nOur products are built for that kind of experience, and designed to perform in retail through strong visual appeal, gifting potential, and repeat purchase behavior.\n\nWe're excited to connect and bring value to the right brick & mortar partners.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:37.113Z",
    importedBy: "entity-db-cli",
  },
};
